export const FORMAT_REFERENCE_URL = '/valueLists/FLEX_VALUE_ALL?sublistCode=TABLE_REPORT_DOWNLOAD_FORMAT';
export const PROGRAMS_REFERENCE_URL = '/valueLists/EXECUTABLE';
